import { postCommunication } from './communicationRequests';
import { api } from './api';
import type {
  AccountUser,
  OrganizationCXProfile,
  OrganizationTextOptions,
  PaginatedResult,
  PlatformActivity,
} from '../types/admin';
const path = (id: string, action: string) => `/api/admin/organizations/${id}/${action}/`;
export const OrganizationProfileAPI = {
  users: async (id: string, search: string, page: number): Promise<PaginatedResult<AccountUser>> =>
    (await api.get<PaginatedResult<AccountUser>>(`${path(id, 'users')}?${new URLSearchParams({search, page: String(page), page_size: '25'})}`)).data,
  profile: async (id: string): Promise<OrganizationCXProfile> =>
    (await api.get<OrganizationCXProfile>(path(id, 'cx-profile'))).data,
  start: async (id: string): Promise<OrganizationCXProfile> =>
    (await api.post<OrganizationCXProfile>(path(id, 'cx-profile'), {})).data,
  timeline: async (id: string, kind: string, page: number): Promise<PaginatedResult<PlatformActivity>> =>
    (
      await api.get<PaginatedResult<PlatformActivity>>(
        `${path(id, 'timeline')}?kind=${encodeURIComponent(kind)}&page=${page}&page_size=25`,
      )
    ).data,
  log: async (
    id: string,
    data: { kind: string; summary: string; body: string; occurred_at?: string },
  ): Promise<void> => {
    await api.post(path(id, 'timeline'), data);
  },
  email: async (id: string, data: { to: string; subject: string; body: string; body_html?: string }): Promise<void> => {
    await api.post(path(id, 'email'), data);
  },
  textOptions: async (id: string, toNumber?: string): Promise<OrganizationTextOptions> =>
    (
      await api.get<OrganizationTextOptions>(
        path(id, 'text-options') +
          (toNumber === undefined ? '' : `?to_number=${encodeURIComponent(toNumber)}`),
      )
    ).data,
  textPermission: async (
    id: string,
    allowed: boolean,
    note: string,
    to_number?: string,
  ): Promise<void> => {
    await api.put(path(id, 'text-options'), {
      allowed,
      note,
      ...(to_number === undefined ? {} : { to_number }),
    });
  },
  text: async (
    id: string,
    from_number: string,
    body: string,
    to_number?: string,
  ): Promise<{ status: string; detail?: string }> =>
    (
      await postCommunication<{ status: string; detail?: string }>(path(id, 'text'), {
        from_number,
        body,
        ...(to_number === undefined ? {} : { to_number }),
      })
    ).data,
};
